import { Link, useParams } from "react-router";
import { useMfgItem } from "@/lib/mfg-catalog";
import { SpineForm } from "./sections/SpineForm";
import { CreateMfgItemForm } from "./sections/CreateMfgItemForm";
import { SubtypeForm } from "./sections/SubtypeForm";
import { PriceBreaksSection } from "./sections/PriceBreaksSection";
import { ChildrenSection } from "./sections/ChildrenSection";

export function MfgCatalogDetailPage() {
  const { id } = useParams();
  const isCreate = id === undefined;
  const itemId = isCreate ? 0 : Number(id);
  const { data: item, isLoading } = useMfgItem(itemId);

  if (isCreate) return (
    <div className="mx-auto max-w-3xl p-6 space-y-4">
      <nav className="text-sm text-muted-foreground"><Link to="/admin/mfg-catalog">Mfg Catalog</Link> ▸ New item</nav>
      <CreateMfgItemForm />
    </div>
  );

  if (isLoading || !item) return <div className="p-6 text-sm text-muted-foreground">Loading…</div>;

  return (
    <div className="mx-auto max-w-3xl p-6 space-y-8">
      <nav className="text-sm text-muted-foreground"><Link to="/admin/mfg-catalog">Mfg Catalog</Link> ▸ {item.name}</nav>
      <SpineForm item={item} />
      <SubtypeForm item={item} />
      <PriceBreaksSection item={item} />
      <ChildrenSection item={item} />
    </div>
  );
}
